import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from '../../../appshared/invoice/cart.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemPictureModule } from '../../../appshared/invoice/item-picture/item-picture.module';
import { ItemModule, ViewItem } from '../../../appshared/invoice/item/item.module';
import { ToastrService } from 'ngx-toastr';
import { ItemService } from '../../../appshared/invoice/item/item.service';
import { CategoryService } from '../../../appshared/invoice/category/category.service';
import { ItemPictureService } from '../../../appshared/invoice/item-picture/item-picture.service';
import { environment } from '../../../../environments/environment';
import { AppLoaderService } from '../../../common/service/app-loader/app-loader.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent {


    sortType: string = "Default";
    Cid: number = 0;
    SCid: number = 0;
    itemPieces: number = 0;


    mainForm: ItemModule = new ItemModule();
  //  mainFormPicture: ItemPictureModule = new ItemPictureModule();

    public SelectedLanguage: string = "en";
    public itemPictureData: ItemPictureModule[] | undefined = [];
    public apiURL: string = "";
    private sub: any;
    ItemId: number = 0;
    ComID: number = 2;

    currentDate = new Date();
    private datas: any;

    public dataSourceItems = new MatTableDataSource<ItemModule>();

    constructor(public dialog: MatDialog, public translate: TranslateService, private route: ActivatedRoute, private toastr: ToastrService, private router: Router, private loader: AppLoaderService, public servItem: ItemService, private serv: CategoryService, public servItemPicture: ItemPictureService,
        private cartService: CartService) {
        if (this.translate.currentLang != undefined) {

            this.SelectedLanguage = this.translate.currentLang;
        }

        if (this.SelectedLanguage == 'ar') {
            this.productsSlidesOptions = {
                loop: true,
                nav: true,
                dots: false,
                autoplayHoverPause: true,
                autoplay: true,
                //margin: 10,
                rtl: true,
                navText: [
                    "<i class='bx bx-right-arrow-alt'></i>",
                    "<i class='bx bx-left-arrow-alt'></i>"
                ],
                responsive: {
                    0: {
                        items: 2,
                        stagePadding: 0
                    },
                    576: {
                        items: 2,
                        stagePadding: 0
                    },
                    768: {
                        items: 3,
                        stagePadding: 0
                    },
                    992: {
                        items: 6,
                        stagePadding: 0
                    },
                    1200: {
                        items: 6,
                        stagePadding: 0
                    }
                }
            }

            this.heroSlides = {
                loop: true,
                nav: false,
                dots: true,
                autoplayHoverPause: true,
                autoplay: true,
                autoWidth: false,
                stagePadding: 0, 
                //margin: 10,
                rtl: true,
                navText: [
                    "<i class='bx bx-right-arrow-alt'></i>",
                    "<i class='bx bx-left-arrow-alt'></i>"
                ],
                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 1
                    },
                    768: {
                        items: 1
                    },
                    992: {
                        items: 1
                    },
                    1200: {
                        items: 1
                    }
                }
            }

            this.slideConfig = {
                ...this.slideConfig,
                rtl: true,
            };
        }
        else {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: false,
            };
        }
        
    }



    ngOnInit(): void {

        this.sub = this.route.params.subscribe(params => {
            this.ItemId = +params['ItemId'];
        });
        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
        this.fillItemPictures();
        this.buildItemForm();
        this.fillItemSold();
    }

    heroSlides: OwlOptions = {
        loop: true,
        nav: true,
        dots: false,
        autoplayHoverPause: true,
        autoplay: true,
        //margin: 10,
        navText: [
            "<i class='bx bx-left-arrow-alt'></i>",
            "<i class='bx bx-right-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1
            },
            768: {
                items: 1
            },
            992: {
                items: 1
            },
            1200: {
                items: 1
            }
        }
    }

    slideConfig = {
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: false,
        arrows: false,
        rtl: false,
        responsive: [
            {
                breakpoint: 768, // screens below 768px
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 440, // even smaller screens
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    fillItemPictures() {
        // this.loader.open();
        this.itemPictureData = [];
        this.servItemPicture.getServiceID(this.ItemId)
            .subscribe((res: ItemPictureModule[]) => {

                this.datas = res as ItemPictureModule[];

                for (var i = 0; i < this.datas.length; i++) {

                    this.itemPictureData.push({ inItemPictureID: this.datas[i].inItemPictureID, inItemID: this.datas[i].inItemID, path: this.datas[i].path });
                }

                this.loader.close();
            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    fillItemSold() {
        // this.loader.open();
        this.servItem.getItemBranchNoSales(this.ComID, this.ItemId, 1)
            .subscribe(res => {
                this.itemPieces = +res;

            },
                (err: any) => {
                    console.log(err);
                });
    }


    buildItemForm() {

        // this.loader.open();
        this.servItem.getServiceViewID(this.ItemId)
            .subscribe((res: any[]) => {
                this.datas = res as ItemModule[];

                this.datas.webDiscountFromDate = new Date(this.datas.webDiscountFromDate);
                this.datas.webDiscountToDate = new Date(this.datas.webDiscountToDate);


                this.mainForm = this.datas;

                this.Cid = this.datas.gnCategoryID;
                this.SCid = this.datas.gnSubCategoryID;

                this.itemPictureData.push({ inItemPictureID: 0, inItemID: this.ItemId, path: this.mainForm.photoPath });

                this.fillItems();
                this.loader.close();
            },
                (err: any) => {
                    this.loader.close(); console.log(err);

                });
    }

    ///////////////////////////////////////////////////
    public slug: any;
    public data: any;
    addToCart(qty: any) {

        this.loader.open();

        var price = this.mainForm.salesPrice;
        if (this.mainForm.activateWebDiscount && this.mainForm.webDiscountFromDate < new Date() && this.mainForm.webDiscountToDate > new Date()) {
            price = this.mainForm.webDiscountAmount;
        }

        var product: ViewItem = {


            inItemID: this.mainForm.inItemID,
            name: this.mainForm.webNameEn,
            nameAr: this.mainForm.webNameAr,
            salesPrice: this.mainForm.salesPrice,
            barcode: this.mainForm.barcode,
            inCategoryID: this.mainForm.inCategoryID,
            description: this.mainForm.description,
            inUnitID: this.mainForm.inUnitID,
            photoPath: this.mainForm.photoPath,
            itemCode: this.mainForm.itemCode,
            unitName: this.mainForm.unitName,
            systemCode: this.mainForm.systemCode,
            categoryNameAr: this.mainForm.categoryNameAr,
            descriptionAr: this.mainForm.descriptionAr,
            categoryName: this.mainForm.categoryName,

            saleTaxPercentage: this.mainForm.saleTaxPercentage,
            isViewWeb: this.mainForm.isViewWeb,
            webDiscountFromDate: this.mainForm.webDiscountFromDate,
            webDiscountToDate: this.mainForm.webDiscountToDate,
            webDiscountAmount: this.mainForm.webDiscountAmount,
            activateWebDiscount: this.mainForm.activateWebDiscount,
            unitNameAr: this.mainForm.unitNameAr,
            webDiscountPercentage: this.mainForm.webDiscountPercentage,
            wholesalePrice: this.mainForm.wholesalePrice,

            cartQuantity: 1,
            cartPrice: price
        };


        this.cartService.addToCart(product, +qty);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');


        //this.servItem.getItemBranchNoSales(this.ComID, this.ItemId, 1)
        //    .subscribe(res => {

        //        this.loader.close();
        //        if (+res >= 1) {


        //            var price = this.mainForm.salesPrice;
        //            if (this.mainForm.activateWebDiscount && this.mainForm.webDiscountFromDate < new Date() && this.mainForm.webDiscountToDate > new Date()) {
        //                price = this.mainForm.webDiscountAmount;
        //            }

        //            var product: ViewItem = {


        //                inItemID: this.mainForm.inItemID,
        //                name: this.mainForm.webNameEn,
        //                nameAr: this.mainForm.webNameAr,
        //                salesPrice: this.mainForm.salesPrice,
        //                barcode: this.mainForm.barcode,
        //                inCategoryID: this.mainForm.inCategoryID,
        //                description: this.mainForm.description,
        //                inUnitID: this.mainForm.inUnitID,
        //                photoPath: this.mainForm.photoPath,
        //                itemCode: this.mainForm.itemCode,
        //                unitName: this.mainForm.unitName,
        //                systemCode: this.mainForm.systemCode,
        //                categoryNameAr: this.mainForm.categoryNameAr,
        //                descriptionAr: this.mainForm.descriptionAr,
        //                categoryName: this.mainForm.categoryName,

        //                saleTaxPercentage: this.mainForm.saleTaxPercentage,
        //                isViewWeb: this.mainForm.isViewWeb,
        //                webDiscountFromDate: this.mainForm.webDiscountFromDate,
        //                webDiscountToDate: this.mainForm.webDiscountToDate,
        //                webDiscountAmount: this.mainForm.webDiscountAmount,
        //                activateWebDiscount: this.mainForm.activateWebDiscount,
        //                unitNameAr: this.mainForm.unitNameAr,
        //                webDiscountPercentage: this.mainForm.webDiscountPercentage,
        //                wholesalePrice: this.mainForm.wholesalePrice,

        //                cartQuantity: 1,
        //                cartPrice: price
        //            };


        //            this.cartService.addToCart(product, +qty);



        //            var transR = this.translate.instant('Your_product_added_to_the_cart');
        //            this.toastr.success(transR, '');



        //        }
        //        else {

        //            var transR = this.translate.instant('This_Item_Out_of_Stock');
        //            this.toastr.warning(transR, '');
        //        }

        //    },
        //        (err: any) => {
        //            console.log(err);
        //        });
    }

    addToCart2(itemM: ItemModule) {

        // var ViewItems = new ViewItem();

        this.loader.open();

        var price = itemM.salesPrice;
        if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
            price = itemM.webDiscountAmount;
        }


        var product: ViewItem = {


            inItemID: itemM.inItemID,
            name: itemM.webNameEn,
            nameAr: itemM.webNameAr,
            salesPrice: itemM.salesPrice,
            barcode: itemM.barcode,
            inCategoryID: itemM.inCategoryID,
            description: itemM.description,
            inUnitID: itemM.inUnitID,
            photoPath: itemM.photoPath,
            itemCode: itemM.itemCode,
            unitName: itemM.unitName,
            systemCode: itemM.systemCode,
            categoryNameAr: itemM.categoryNameAr,
            descriptionAr: itemM.descriptionAr,
            categoryName: itemM.categoryName,

            saleTaxPercentage: itemM.saleTaxPercentage,
            isViewWeb: itemM.isViewWeb,
            webDiscountFromDate: itemM.webDiscountFromDate,
            webDiscountToDate: itemM.webDiscountToDate,
            webDiscountAmount: itemM.webDiscountAmount,
            activateWebDiscount: itemM.activateWebDiscount,
            unitNameAr: itemM.unitNameAr,
            webDiscountPercentage: itemM.webDiscountPercentage,
            wholesalePrice: itemM.webDiscountPercentage,

            cartQuantity: 1,
            cartPrice: price

        };



        this.cartService.addToCart(product, 1);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');


        //this.servItem.getItemBranchNoSales(this.ComID, itemM.inItemID, 1)
        //    .subscribe(res => {

        //        this.loader.close();
        //        if (+res >= 1) {



        //            var price = itemM.salesPrice;
        //            if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
        //                price = itemM.webDiscountAmount;
        //            }


        //            var product: ViewItem = {


        //                inItemID: itemM.inItemID,
        //                name: itemM.webNameEn,
        //                nameAr: itemM.webNameAr,
        //                salesPrice: itemM.salesPrice,
        //                barcode: itemM.barcode,
        //                inCategoryID: itemM.inCategoryID,
        //                description: itemM.description,
        //                inUnitID: itemM.inUnitID,
        //                photoPath: itemM.photoPath,
        //                itemCode: itemM.itemCode,
        //                unitName: itemM.unitName,
        //                systemCode: itemM.systemCode,
        //                categoryNameAr: itemM.categoryNameAr,
        //                descriptionAr: itemM.descriptionAr,
        //                categoryName: itemM.categoryName,

        //                saleTaxPercentage: itemM.saleTaxPercentage,
        //                isViewWeb: itemM.isViewWeb,
        //                webDiscountFromDate: itemM.webDiscountFromDate,
        //                webDiscountToDate: itemM.webDiscountToDate,
        //                webDiscountAmount: itemM.webDiscountAmount,
        //                activateWebDiscount: itemM.activateWebDiscount,
        //                unitNameAr: itemM.unitNameAr,
        //                webDiscountPercentage: itemM.webDiscountPercentage,
        //                wholesalePrice: itemM.webDiscountPercentage,

        //                cartQuantity: 1,
        //                cartPrice: price

        //            };



        //            this.cartService.addToCart(product, 1);


        //            var transR = this.translate.instant('Your_product_added_to_the_cart');
        //            this.toastr.success(transR, '');


        //        }
        //        else {

        //            var transR = this.translate.instant('This_Item_Out_of_Stock');
        //            this.toastr.warning(transR, '');
        //        }

        //    },
        //        (err: any) => {
        //            console.log(err);
        //        });


    }

    counter(i: number) {
        return new Array(i);
    }



    onCategoryChange(catID: any) {

        this.router.navigate(['shop', { catID: catID }]);

    }

    onSubcategoryChange(catID: any) {
        this.router.navigate(['shop', { scatID: catID }]);
    }




    fillItems() {
        this.dataSourceItems = new MatTableDataSource<ItemModule>();
        this.loader.open();
        this.servItem.getService(this.ComID, this.Cid, this.SCid, '', this.sortType)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);
                }

                this.dataSourceItems.data = res;

            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    onClickItem(ItemId: number) {
        this.router.navigate(['product-details', { ItemId: ItemId }]);
        this.ItemId = ItemId;
        this.buildItemForm();
        this.fillItemPictures();
    }

    productsSlidesOptions: OwlOptions = {
        loop: true,
        nav: false,
        dots: true,
        autoplayHoverPause: true,
        autoplay: true,
        //margin: 10,
        navText: [
            "<i class='bx bx-left-arrow-alt'></i>",
            "<i class='bx bx-right-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2,
                stagePadding: 0
            },
            768: {
                items: 3,
                stagePadding: 0
            },
            992: {
                items: 4,
                stagePadding: 0
            },
            1200: {
                items: 4,
                stagePadding: 0
            }
        }
    }


    onClickNextItem(currentIndex: number) {
        const nextIndex = currentIndex + 1;
        const nextItemId = this.dataSourceItems.data[nextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: nextItemId }]);
    }
    getNextImage(currentIndex: number): string | null {
        const nextIndex = currentIndex + 1;
        if (nextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[nextIndex].photoPath;
        }
        return null; // No next image
    }

    onClickAfterNextItem(currentIndex: number) {
        const afterNextIndex = currentIndex + 2;
        const AfternextItemId = this.dataSourceItems.data[afterNextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: AfternextItemId }]);
    }
    getAfterNextImage(currentIndex: number): string | null {
        const afterNextIndex = currentIndex + 2;
        if (afterNextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[afterNextIndex].photoPath;
        }
        return null; // No after next image
    }


    onClickAfterAfterNextItem(currentIndex: number) {
        const afterAfterNextIndex = currentIndex + 3;
        const AfterAfternextItemId = this.dataSourceItems.data[afterAfterNextIndex].inItemID;
        this.router.navigate(['product-details', { ItemId: AfterAfternextItemId }]);
    }
    getAfterAfterNextImage(currentIndex: number): string | null {
        const afterAfterNextIndex = currentIndex + 3;
        if (afterAfterNextIndex < this.dataSourceItems.data.length) {
            return this.apiURL + this.dataSourceItems.data[afterAfterNextIndex].photoPath;
        }
        return null; // No after after next image
    }

}
